import { render, staticRenderFns } from "./vehicleFlowing.vue?vue&type=template&id=627f1d5f"
import script from "./vehicleFlowing.vue?vue&type=script&lang=js"
export * from "./vehicleFlowing.vue?vue&type=script&lang=js"
import style0 from "./vehicleFlowing.vue?vue&type=style&index=0&id=627f1d5f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports